var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.932,
    height: 70.933,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c0cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#734cfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#f4318d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec5623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "c",
    x1: 1,
    x2: 0,
    y1: 0.757,
    y2: 0.242
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.933,
    height: 70.933,
    fill: "url(#a)",
    rx: 19
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 20.536A17.946 17.946 0 0 1 15.4 2.785V13.3a7.687 7.687 0 1 0 9.8 9.8h10.521A17.952 17.952 0 0 1 0 20.536m38.5 0H23.1a5.137 5.137 0 0 0-5.131-5.136V0a20.56 20.56 0 0 1 20.536 20.535Zm-17.964-7.261a7.8 7.8 0 0 1 4.694 4.694h10.526a18.01 18.01 0 0 0-15.22-15.22Z",
    "data-name": "Combined Shape"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 532"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Color/Primary",
    opacity: 0.201
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.933,
    height: 70.933,
    fill: "url(#a)",
    "data-name": "Mask",
    rx: 19
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    "data-name": "Color/Primary"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M0 0h70.933v70.933H0z",
    "data-name": "Color/Primary"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16.212 36.749a17.946 17.946 0 0 1 15.4-17.751v10.515a7.687 7.687 0 1 0 9.8 9.8h10.521a17.952 17.952 0 0 1-35.721-2.564m38.5 0h-15.4a5.137 5.137 0 0 0-5.131-5.136v-15.4a20.56 20.56 0 0 1 20.536 20.535Zm-17.964-7.261a7.8 7.8 0 0 1 4.694 4.694h10.526a18.01 18.01 0 0 0-15.22-15.22Z",
    "data-name": "Combined Shape"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    "data-name": "Mask Group 6",
    transform: "translate(16.212 16.213)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uD83C\\uDFA8 color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ec5623",
    d: "M0 0h38.506v38.506H0z",
    "data-name": "Rectangle"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon1);
export default __webpack_public_path__ + "static/media/serviceIcon1.3eab71e76c48fd8c76c10c1aa97d1d86.svg";
export { ForwardRef as ReactComponent };